<template>
  <div>
    <span
      class="mr-1"
      v-b-tooltip.hover
      :title="dokumenteTooltipText"
      :class="statusClass(vorgang.teilnehmerdatenStatus)"
    >
      <UserCheck :size="16" />
    </span>
    <span
      class="mr-1"
      v-b-tooltip.hover
      :title="reiseleistungenUndListenversandTooltipText"
      :class="statusClass(vorgang.reiseleistungListenversandStatus)"
    >
      <Luggage :size="16" />
    </span>
    <span
      v-if="!isReiseOhneFlug"
      class="mr-1"
      v-b-tooltip.hover
      :title="fluegeTooltipText"
      :class="statusClass(vorgang.fluegeStatus)"
    >
      <Plane :size="16" />
    </span>
    <span
      v-if="!dachReise && !isReiseOhneFlug"
      class="mr-1"
      v-b-tooltip.hover
      title="Transferplanung Vorgangebene"
      :class="statusClass(vorgang.transferplanungStatus)"
    >
      <Car :size="16" />
    </span>
  </div>
</template>

<script>
import { UserCheck, Luggage, Plane, Car } from 'lucide-vue';

const STATUS_CLASS_MAP = {
  AllGood: 'text-success',
  CheckRequired: 'text-warning',
  Critical: 'text-danger',
};

export default {
  components: { UserCheck, Luggage, Plane, Car },
  props: {
    vorgang: { type: Object },
    isKeineTransferplanungNotwendigHin: { type: Boolean },
    isKeineTransferplanungNotwendigRueck: { type: Boolean },
    isReiseOhneFlug: { type: Boolean, default: false },
  },
  computed: {
    dachReise() {
      if (!this.vorgang || !this.vorgang.hotelleistungen) return false;
      return (
        this.vorgang.hotelleistungen.every(hl => hl.reisetermin?.reise?.region === 'Dach') ||
        (this.isKeineTransferplanungNotwendigHin && this.isKeineTransferplanungNotwendigRueck)
      );
    },
  },
  methods: {
    statusClass(status) {
      return STATUS_CLASS_MAP[status] || 'text-danger';
    },
    dokumenteTooltipText() {
      const status = this.vorgang.teilnehmerdatenStatus;
      if (status === 'AllGood') return 'Teilnehmerdaten vollständig.';
      if (status === 'CheckRequired') return 'Teilnehmerdaten teilweise unvollständig.';
      return 'Teilnehmerdaten unvollständig.';
    },
    reiseleistungenUndListenversandTooltipText() {
      const status = this.vorgang.reiseleistungListenversandStatus;
      return status === 'AllGood'
        ? 'Reiseleistungen & Listenversand geprüft.'
        : status === 'Critical'
        ? 'Reiseleistungen & Listenversand nicht geprüft.'
        : 'Prüfung Reiseleistungen & Listenversand in Arbeit.';
    },
    fluegeTooltipText() {
      if (this.vorgang.fluegeStatus === 'AllGood') {
        return 'Flüge durch FOM geprüft.';
      }
      if (this.vorgang.fluegeStatus === 'CheckRequired' || this.vorgang.fluegeStatus === 'Critical') {
        return 'Flüge durch FOM nicht geprüft.';
      }

      return `Flüge ${this.vorgang.fluegeStatus === 'Critical' ? '' : 'nicht'} geprüft & Flugticket ${
        this.vorgang.flugticketAusgestellt ? '' : 'nicht'
      } ausgestellt.`;
    },
  },
};
</script>
